import { createFileRoute, Link } from "@tanstack/react-router";
import Calendar from "@repo/icons/default/Calendar";
import CreditCard from "@repo/icons/default/CreditCard";
import Doctor from "@repo/icons/default/Doctor";
import UsersV2 from "@repo/icons/default/UsersV2";
import { Page } from "@/components/ui/layout/page/page";
import { HeaderRoot, HeaderTitle } from "@/components/ui/layout/header/header";
import {
  GridCardItem,
  GridCardItemIcon,
  GridCardItemText,
  GridCardRoot,
} from "@/components/ui/card/grid-card";
import { env } from "@/lib/utils/env";
import { EmptyStateButton } from "@/components/ui/empty-state/empty-state";
import { trackEvent } from "@/lib/tracking";

import type { JSX } from "react";

const AccessBlockedPage = (): JSX.Element => {
  const handleClickActiveAccount = (): void => {
    trackEvent("Botão Reativar Conta Acesso Bloqueado Clicado");
  };

  return (
    <>
      <HeaderRoot>
        <HeaderTitle title="Livance" align="center" />
      </HeaderRoot>
      <Page className="px-0 pb-0 flex flex-col h-screen overflow-scroll relative max-w-lg mx-auto">
        <div className="px-4 flex-col flex gap-4 pt-4">
          <p className="text-2xl font-semibold text-left ">Sua conta está desativada</p>
          <div className="space-y-2">
            <p>No momento, você não tem acesso ao sistema Livance.</p>
            <p>
              Para voltar a utilizar todos os recursos e benefícios, reative sua conta
              agora mesmo.
            </p>
          </div>
          <GridCardRoot>
            <GridCardItem>
              <GridCardItemIcon>
                <Doctor size={24} />
              </GridCardItemIcon>
              <GridCardItemText>
                Atenda seus pacientes nas <strong>melhores localizações</strong>.
              </GridCardItemText>
            </GridCardItem>

            <GridCardItem>
              <GridCardItemIcon>
                <Calendar size={24} />
              </GridCardItemIcon>
              <GridCardItemText>
                Gerencie sua agenda com <strong>ferramentas avançadas</strong>.
              </GridCardItemText>
            </GridCardItem>

            <GridCardItem>
              <GridCardItemIcon>
                <CreditCard size={24} />
              </GridCardItemIcon>
              <GridCardItemText>
                <strong>Receba os pagamentos</strong> de seus pacientes de forma fácil.
              </GridCardItemText>
            </GridCardItem>

            <GridCardItem>
              <GridCardItemIcon>
                <UsersV2 size={24} />
              </GridCardItemIcon>
              <GridCardItemText>
                Junte-se a mais de <strong>8000 profissionais</strong> e aproveite nossa
                comunidade.
              </GridCardItemText>
            </GridCardItem>
          </GridCardRoot>

          <div className="flex flex-col gap-3 w-full mt-4">
            <a
              href={env.VITE_ANIMUS_URL}
              target="_blank"
              className="w-full"
              rel="noopener noreferrer"
              onClick={handleClickActiveAccount}
            >
              <EmptyStateButton fullWidth>Reativar minha conta agora</EmptyStateButton>
            </a>
            <Link to="/auth/logout" preload={false} className="w-full">
              <EmptyStateButton fullWidth variant="outlined">
                Sair do aplicativo
              </EmptyStateButton>
            </Link>
          </div>
        </div>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/access-blocked/")({
  component: AccessBlockedPage,
});
